/**
 * IP from a CloudFront-Viewer-Address value ("ip:port"; IPv6 is NOT bracketed,
 * e.g. "2600:1f18::52af:38574"). Only a trailing port is stripped, so an IPv6
 * address keeps every group. Also accepts "[v6]:port" and a bare IP. Returns
 * null for anything that is not an IP.
 */
export function ipFromViewerAddress(raw: string): string | null {
  const s = raw.trim();
  const bracketed = /^\[([0-9A-Fa-f:.]+)\](?::\d{1,5})?$/.exec(s);
  if (bracketed) return isIPv6(bracketed[1]) ? bracketed[1] : null;

  const v4 = /^(\d{1,3}(?:\.\d{1,3}){3})(?::\d{1,5})?$/.exec(s);
  if (v4) return isIPv4(v4[1]) ? v4[1] : null;

  // CloudFront always appends the port, so try "address:port" first. A bare
  // IPv6 whose last group happens to be decimal would otherwise lose it.
  const i = s.lastIndexOf(':');
  if (i > 0 && /^\d{1,5}$/.test(s.slice(i + 1)) && isIPv6(s.slice(0, i))) return s.slice(0, i);
  return isIPv6(s) ? s : null;
}

function isIPv4(s: string): boolean {
  return s.split('.').every((o) => Number(o) <= 255);
}

function isIPv6(s: string): boolean {
  if (!/^[0-9A-Fa-f:.]+$/.test(s) || !s.includes(':')) return false;
  const compressed = s.split('::');
  if (compressed.length > 2) return false;
  const groups = s.split(':').filter((g) => g !== '');
  if (groups.some((g) => !/^[0-9A-Fa-f]{1,4}$/.test(g) && !(g.includes('.') && isIPv4(g)))) return false;
  return compressed.length === 2 ? groups.length < 8 : groups.length === 8;
}
